import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Equipment } from '../types/equipment';

interface EquipmentContextType {
  equipment: Equipment[];
  setEquipment: (equipment: Equipment[]) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

const EquipmentContext = createContext<EquipmentContextType | undefined>(undefined);

export const useEquipment = () => {
  const context = useContext(EquipmentContext);
  if (context === undefined) {
    throw new Error('useEquipment must be used within an EquipmentProvider');
  }
  return context;
};

interface EquipmentProviderProps {
  children: ReactNode;
}

export const EquipmentProvider: React.FC<EquipmentProviderProps> = ({ children }) => {
  // 使用空數組，讓各頁面自己管理數據
  const [equipment, setEquipment] = useState<Equipment[]>([]);
  const [loading, setLoading] = useState(false);

  const value = {
    equipment,
    setEquipment,
    loading,
    setLoading,
  };

  return (
    <EquipmentContext.Provider value={value}>
      {children}
    </EquipmentContext.Provider>
  );
};
